<!-- https://8es9hr.axshare.com/#g=1&p=%E4%BA%A4%E6%98%93%E6%98%8E%E7%B4%B0%E6%A0%B8%E5%B0%8D -->
<!-- 交易明細核對 -->
<template>
    <div class="row">
        <div class="col-12">
            <div class="col-block">
                <div class="block-header has-border">
                    <h3>
                        <!-- <strong>{{detail.member.account + ' ' + detail.member.idNumber + ' ' + detail.member.name}}</strong> -->
                    </h3>
                    <br />
                    <h3>
                        <strong>社員轉帳備忘錄 交易明細核對</strong>
                    </h3>
                </div>
                <div class="block-content">
                    <!-- 選擇的備忘錄 -->
                    <el-card class="box-card">
                        <p>您選擇的備忘錄</p>
                        <el-table :data="transferMemo"
                                  tooltip-effect="dark"
                                  border
                                  style="width: 100%"
                                  @selection-change="handleSelectionChange"
                                  :header-cell-style="{background:'#f5f5f5'}">
                            <el-table-column label="銀行"
                                             prop="bankName">
                                <template slot-scope="scope">{{ bank.bankName }}</template>
                            </el-table-column>
                            <el-table-column prop="updateTime"
                                             label="匯款日期">
                                <template slot-scope="scope">{{ formatMinGoDate(scope.row.transferDate) }}</template>
                            </el-table-column>
                            <el-table-column prop="transferAccountNumber"
                                             label="帳號後五碼"></el-table-column>
                            <el-table-column prop="transferAmount"
                                             label="匯款金額"></el-table-column>
                            <el-table-column prop="updateUserName"
                                             label="最後修改人"></el-table-column>
                            <el-table-column prop="updateTime"
                                             label="最後修改時間">
                                <template slot-scope="scope">{{ formatMinGoDate(scope.row.updateTime) }}</template>
                            </el-table-column>
                            <el-table-column prop="note"
                                             label="用途說明"></el-table-column>
                        </el-table>
                    </el-card>
                    <!-- 對應的銀行交易明細 -->
                    <el-card class="box-card">
                        <p>對應的銀行交易明細</p>
                        <el-table :data="BankTransaction"
                                  tooltip-effect="dark"
                                  border
                                  style="width: 100%"
                                  @selection-change="handleSelectionChange"
                                  :header-cell-style="{background:'#f5f5f5'}">
                            <el-table-column label="操作"
                                             width="100">
                                <template slot-scope="scope">
                                    <el-button type="danger"
                                               size="small"
                                               plain
                                               @click="removeItem(scope.row)">刪除</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column label="交易時間">
                                <template slot-scope="scope">{{formatMinGoDate(scope.row.tradeTime)}}</template>
                            </el-table-column>
                            <el-table-column prop="summary"
                                             label="摘要"></el-table-column>
                            <el-table-column prop="inAmount"
                                             label="收入金額"></el-table-column>
                            <el-table-column prop="outAmount"
                                             label="收入金額"></el-table-column>
                            <el-table-column prop="balance"
                                             label="結餘"></el-table-column>
                            <el-table-column label="其他社員對應"
                                             width="250">
                                <template slot-scope="scope">
                                    <el-button type="primary"
                                               v-for="(transfer,index) in scope.row.transferMemo"
                                               :key="index"
                                               class="mt10 btn-mg"
                                               @click="transferData(transfer)">{{`${formatMinGoDate(transfer.transferDate)} 對應社員 ${transfer.memberName}`}}</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column prop="note"
                                             label="備註"></el-table-column>
                        </el-table>
                    </el-card>
                    <!-- 請勾選對應的銀行交易明細 -->
                    <el-card class="box-card">
                        <workbench api="coopBankTransactionCheck"
                                   :columns="columns"
                                   :toolbar="toolbar"
                                   :query="query"
                                   :filter="filter"
                                   class="mt10"
                                   ref="list">
                            <template slot="button">
                                <div class="filter-group ml10">
                                    <span class="filter-label">銀行交易明細查詢日期</span>
                                    <div class="date">
                                        <input type="text"
                                               class="min_go_date tradeDate"
                                               placeholder="選擇日期" />
                                        <span class="el-input__prefix"><i class="el-icon-date"></i></span>
                                    </div>
                                    <el-button type="primary"
                                               class="mb10 ml10"
                                               plain
                                               @click="searchBankTransaction">查詢</el-button>
                                </div>
                            </template>
                        </workbench>
                        <el-button type="primary"
                                   class="mt10"
                                   plain
                                   @click="batchAppend">加入對應清單</el-button>
                    </el-card>
                    <el-button class="mt10"
                               @click="back">返回</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { API } from "@/assets/config";
import Workbench from "@/components/Workbench";
export default {
    name: "cabinet_transfer_detail",
    components: { Workbench },
    data() {
        return {
            id: this.$route.params.subId,
            detail: this.$route.params.dataArr,
            recordToEdit: {},
            filter: {},
            bank: [],
            transferMemo: [],
            BankTransaction: [],
            searchDate: "",
            toolbar: {
                addable: false,
                editable: false,
                removeable: false
            },
            query: {
                memoId: this.$route.params.subId,
                action: "getNotCheckTransaction"
            },
            columns: [
                {
                    label: "交易時間",
                    prop: "tradeTime",
                    renderFunction: (h, scope) => {
                        return h(
                            "div",
                            scope.row.tradeTime
                                ? scope.row.tradeTime.split(" ")[0]
                                : ""
                        );
                    }
                },
                {
                    label: "摘要",
                    prop: "summary"
                },
                {
                    label: "收入金額",
                    prop: "inAmount"
                },
                {
                    label: "支出金額",
                    prop: "outAmount"
                },
                {
                    label: "結餘",
                    prop: "balance"
                },
                {
                    label: "其他社員對應",
                    prop: "",
                    renderFunction: (h, scope, enumData) => {
                        let rowArray = scope.row.transferMemo.map(transfer =>
                            h(
                                "el-button",
                                {
                                    props: {
                                        type: "primary",
                                        plain: true
                                    },
                                    on: {
                                        click: () => {
                                            this.transferData(transfer);
                                        }
                                    }
                                },
                                `${this.formatMinGoDate(
                                    transfer.transferDate
                                )} 對應社員 ${transfer.memberName}`
                            )
                        );
                        return h(
                            "div",
                            {
                                style: {
                                    "text-align": "center"
                                }
                            },
                            rowArray
                        );
                    },
                    width: "150"
                },
                {
                    label: "備註",
                    prop: "note"
                }
            ],
            multipleSelection: []
        };
    },
    created() {
        this.getTrasferMemo();
        this.getBankTransaction();
    },
    methods: {
        formatMinGoDate(dateTime) {
            //ex:1990-01-01 00:00:00
            let dateArray = dateTime.split(" ")[0].split("-");
            return `${parseInt(dateArray[0]) - 1911}-${dateArray[1]}-${
                dateArray[2]
            }`;
        },
        batchAppend() {
            let idList = this.$refs.list.multipleSelection.map(sel => sel.id);

            if (idList.length == 0) {
                this.$message({
                    type: "error",
                    message: "尚未選擇要加入對應清單的資料",
                    duration: 5000
                });
                return;
            }

            let api = API.coopBankTransactionCheck + "?action=batchAppend";

            const form = new FormData();
            form.append("transactionIdList", JSON.stringify(idList));
            form.append("memoId", this.id);
            let thenCB = json => {
                this.showAjaxSuccessMsg();
                this.getTrasferMemo();
                this.getBankTransaction();
                this.$refs.list.getData();
            };
            this.mAxiosPost(api, form, thenCB);
        },
        getTrasferMemo() {
            //你選擇的備忘錄
            const url = API.memberTransferMemo + `?id=${this.id}`;
            const thenCB = json => {
                this.recordToEdit = Object.assign(
                    {},
                    this.recordToEdit,
                    json.resultData.data
                );
                this.transferMemo = Array(json.resultData.data);
                this.bank = json.resultData.enumData;
                // .enumData.bank;
            };
            this.mAxiosGet(url, thenCB);
        },
        getBankTransaction() {
            //對應的銀行交易明細
            const url =
                API.coopBankTransactionCheck +
                `?action=getCheckTransaction&memoId=${this.id}`;
            const thenCB = json => {
                this.BankTransaction = json.resultData.data;
            };
            this.mAxiosGet(url, thenCB);
        },
        searchBankTransaction() {
            let tradeDate = $(".tradeDate").val();

            if (tradeDate !== "") {
                let tradeDateArray = tradeDate.split(" ")[0].split("-");
                this.filter.searchDate = `${parseInt(tradeDateArray[0]) +
                    1911}-${tradeDateArray[1]}-${tradeDateArray[2]}`;
            } else {
                delete this.filter.searchDate;
            }
            this.$refs.list.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        removeItem(item) {
            let url = API.coopBankTransactionCheck;
            this.$http
                .delete(url, {
                    params: {
                        action: "removeTransactionCheck",
                        memoId: this.id,
                        select: {
                            FieldName: "id",
                            IsAllSelect: false,
                            MemberSelectJson: JSON.stringify([item.id])
                        }
                    }
                })
                .then(response => {
                    this.loading = false;
                    this.getTrasferMemo();
                    this.getBankTransaction();
                    this.$refs.list.getData();
                    this.showAjaxSuccessMsg("remove");
                })
                .catch(error => {
                    this.loading = false;
                    this.postErrorHandler("remove");
                });
        },
        transferData(transfer) {
            // 銀行交易明細管理
            let routeData = this.$router.resolve({
                name: "bank_transaction_edit",
                params: { id: transfer.coopBankTransactionId }
            });
            window.open(routeData.href, "_blank");
        },
        back() {
            // 回原本的入口：路徑帶 :id 代表從社員個人頁進來，回該社員的備忘錄，否則回全社列表
            const memberId = this.$route.params.id;

            this.$router.push(
                memberId == null
                    ? { name: "cabinet_transfer_all" }
                    : { name: "cabinet_transfer", params: { id: memberId } }
            );
        }
    }
};
</script>
<style lang="scss" scoped>
.block-content {
    .box-card {
        margin-bottom: 10px;

        &:last-child {
            margin-bottom: 0;
        }
    }
}
.btn-mg {
    margin-left: 0;
}
</style>